var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-greeting-preview"},[_c('VFLabel',{attrs:{"desc":"","text":'Forhåndsvisning av melding'}}),_c('div',{staticClass:"vf-greeting-preview-msg flw100"},[_vm._v(" "+_vm._s(_vm.renderedMessage)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }